// Angular Imports
// =========================================================
import { Component, type OnInit } from '@angular/core'
// Prime NG Imports
// =========================================================
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog'

@Component({
  standalone: false,
  selector: 'app-oh-oo-modal',
  templateUrl: './oh-oo-modal.component.html',
  styleUrls: ['./oh-oo-modal.component.scss']
})
export class OhOoModalComponent implements OnInit {
  modalTitle: string = 'On Hand / On Order'

  sizes: string[] = []
  committed: Record<string, number> | null = null
  // one row per DC this job's uncommitted inventory was sourced from --
  // usually just one, but never assume that, a job can span more than one.
  uncommitted: Array<Record<string, number | string>> | null = null

  hasData: boolean = false

  constructor (private readonly ref: DynamicDialogRef, public config: DynamicDialogConfig) {
    console.log('---> OH/OO Modal: ', config.data)
    this.modalTitle = config.data?.title || this.modalTitle
    this.sizes = config.data?.sizes || []
    this.committed = config.data?.committed || null
    this.uncommitted = config.data?.uncommitted?.length ? config.data.uncommitted : null
    this.hasData = Boolean(this.committed) || Boolean(this.uncommitted)
  }

  ngOnInit () {}

  close (data?: any) {
    if (this.ref) this.ref.close(data || null)
  }
}
